export default __webpack_public_path__ + "static/Tatev Qalashyan -cd5b4c4134c6accc1a4727cfc683f87a.png";